import React, { useState, useEffect, useRef } from 'react';
import './CustomCursor.css';

const CustomCursor = () => {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [cursorVariant, setCursorVariant] = useState('default');
  const [isVisible, setIsVisible] = useState(false);
  const [isClicking, setIsClicking] = useState(false);
  const cursorRef = useRef(null);

  useEffect(() => {
    
    const updateCursorPosition = (e) => {
      // Actualización directa sin requestAnimationFrame para mayor fluidez
      setCursorPosition({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
    };

    const handleMouseLeave = () => {
      setIsVisible(false);
    };

    const handleMouseEnter = () => {
      setIsVisible(true);
    };

    const handleMouseDown = () => {
      setIsClicking(true);
      setCursorVariant('click');
    };

    const handleMouseUp = () => {
      setIsClicking(false);
      // El variant se restablecerá automáticamente por los event listeners
    };

    // Función para agregar listeners de manera más eficiente
    const addCursorListeners = () => {
      // Botones
      const buttons = document.querySelectorAll('button, .btn, .overlay-btn, .primary-btn, .secondary-btn');
      buttons.forEach(button => {
        button.addEventListener('mouseenter', () => setCursorVariant('button'));
        button.addEventListener('mouseleave', () => setCursorVariant('default'));
      });

      // Enlaces
      const links = document.querySelectorAll('a');
      links.forEach(link => {
        link.addEventListener('mouseenter', () => setCursorVariant('link'));
        link.addEventListener('mouseleave', () => setCursorVariant('default'));
      });

      // Elementos con hover
      const hoverElements = document.querySelectorAll('.project-card, .card-inner, .tech-tag, .work-container, .projects-scroll');
      hoverElements.forEach(element => {
        element.addEventListener('mouseenter', () => setCursorVariant('hover'));
        element.addEventListener('mouseleave', () => setCursorVariant('default'));
      });

      // Elementos de navegación
      const navElements = document.querySelectorAll('.navbar, .nav-item, .nav-link');
      navElements.forEach(element => {
        element.addEventListener('mouseenter', () => setCursorVariant('link'));
        element.addEventListener('mouseleave', () => setCursorVariant('default'));
      });
    };

    // Event listeners principales
    document.addEventListener('mousemove', updateCursorPosition, { passive: true });
    document.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('mouseenter', handleMouseEnter);
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    // Agregar listeners para elementos interactivos
    addCursorListeners();

    // Re-agregar listeners cuando el DOM cambie
    const observer = new MutationObserver(() => {
      addCursorListeners();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Cleanup
    return () => {
      document.removeEventListener('mousemove', updateCursorPosition);
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseenter', handleMouseEnter);
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
      observer.disconnect();
    };
  }, []);

  // No mostrar en dispositivos móviles
  if (typeof window !== 'undefined' && window.innerWidth <= 768) {
    return null;
  }

  if (!isVisible) return null;

  return (
    <>
      {/* Cursor principal minimalista */}
      <div
        ref={cursorRef}
        className={`custom-cursor ${cursorVariant} ${isClicking ? 'click' : ''}`}
        style={{
          left: cursorPosition.x - 6,
          top: cursorPosition.y - 6,
        }}
      />
    </>
  );
};

export default CustomCursor;
